let token = null;

const tokenService = {
    getToken: () => token,
    setToken: (tk) => {
        token = tk;
    },
    resetToken: () => {
        token = null;
    }
}

export default tokenService;